import { ui } from "components/util/uiHelpers";
import * as React from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";


type ColumnContentProps = {
    children?: React.ReactNode;
    disableMargin?: boolean;
    style?: React.CSSProperties;
}

export const HouseholdInsuranceColumnContent = ({ children, disableMargin, style }: ColumnContentProps) => {
    const isMobile = externalInterfaceStore.isGeorgeApp || ui.windowWidth < 600;

    return (
        <div
            style={{
                flex: 1,
                textAlign: "left",
                ...(isMobile && { width: "100%" }),
                ...(!isMobile && !disableMargin && { margin: "0 auto" }),
                ...style,
            }}
        >
            {children}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/householdInsurance/components/HouseholdInsuranceColumnContent.tsx